'use client';

import { GridItem, GridItemProps } from '@coolblue-development/freddy';
import buttonHoverTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentInteraction/buttonHoverTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { WorkArea } from '@graphQLTypes';

import { ANALYTICS_DEPARTMENT_SUBFEATURES } from './constants';

type Props = GridItemProps & {
  itemId: number;
  cardTitle: string;
  department: WorkArea | 'culture';
};

export const GridCardWrapper = ({ itemId, cardTitle, department, children, ...props }: Props) => {
  const { trackEvent } = useAnalytics();

  const subFeature = ANALYTICS_DEPARTMENT_SUBFEATURES[department] as Parameters<
    typeof buttonHoverTrigger
  >[0]['sub_feature'];

  return (
    <GridItem
      {...props}
      onMouseEnter={() => {
        trackEvent(
          buttonHoverTrigger({ item_id: itemId, title: cardTitle, sub_feature: subFeature })
        );
      }}
      onFocus={() => {
        trackEvent(
          buttonHoverTrigger({ item_id: itemId, title: cardTitle, sub_feature: subFeature })
        );
      }}
    >
      {children}
    </GridItem>
  );
};
